import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { WebSocketSubject } from 'rxjs/webSocket'
import { environment } from 'src/environments/environment'

import { Character, Room } from '@mmocld/data'
import { Message, RoomJoinBody, RoomJoinSendMessage, RoomLeaveSendMessage } from '@mmocld/message'

import { WsService } from '../api/ws.service'

@Injectable({
  providedIn: 'root',
})
export class RoomService {
  private url = environment.fdiHttpUrl

  constructor(private http: HttpClient, private wsService: WsService) {}

  getAll() {
    return this.http.get<Room[]>(this.url + '/room')
  }

  getOwn(character: Character) {
    return this.http.get<Room>(this.url + '/room/own', { headers: { 'X-MMOCLD-CHARACTERID': character.characterId } })
  }

  join(ws: WebSocketSubject<Message>, body: RoomJoinBody) {
    this.wsService.send(ws, <RoomJoinSendMessage>{
      action: '/room/join',
      body: body,
    })
  }

  leave(ws: WebSocketSubject<Message>) {
    this.wsService.send(ws, <RoomLeaveSendMessage>{
      action: '/room/leave',
    })
  }
}
